export default __webpack_public_path__ + "static/media/dummy-testimonial.5158e375.webp";